import util from '../util'

let base = window.$servicePath


export default {
  /**
   * 关注工作列表
   */
  listAttention(params) {
    return util.ajax(`${base}/api/process/listAttention`, params)
  },
  /**
   * 被催文件列表
   * @param params
   * @returns {*}
   */
  listUrged(params){
    return util.ajax(`${base}/api/process/listUrged`, params)
  },
  addAttention(taskIds){
    return util.ajax(`${base}/api/process/addAttention`, taskIds, null);
  },
  removeAttentionByBusiness(draftsDocIds){
    return util.ajax(`${base}/api/process/removeAttentionByBusiness`, draftsDocIds);
  },
  removeAttention(ids){
    return util.ajax(`${base}/api/process/removeAttention`, ids);
  },
  addUrge(params){
    return util.ajax(`${base}/api/process/addUrge`, params);
  },

  listComment(params){
    return util.ajax(`${base}/api/process/listComment`, params);
  },

  listAttachment(params){
    return util.ajax(`${base}/api/business/listAttachment`, params);
  },
  checkAttachmentIsExist(params){
    return util.ajax(`${base}/api/business/checkAttachmentIsExist`, params);
  },
  /**
   * @param formKey 表单key
   * @param businessId  业务ID
   * @param toBusinessId 临时表业务ID  可不传，后台生产返回
   */
  copyAttachment(...args){
    return util.ajax(`${base}/api/business/copyAttachment`, ...args);
  },
  /**
   * 选择性的拷贝附件
   * @param params
   *           fromBusinessId  业务ID
   *           formKey         表单Key
   * @returns {result:返回临时文档ID, success:true/false}
   */
  selectiveCopyAttachment(params){
    return util.ajax(`${base}/api/business/selectiveCopyAttachment`, params);
  },
  updateAttachment(params){
    return util.ajax(`${base}/api/business/updateAttachment`, params);
  },
  updateAttachmentSn(params){
    return util.ajax(`${base}/api/business/updateAttachmentSn`, params);
  },

  deleteAttachment(params){
    return util.ajax(`${base}/api/business/deleteAttachment`, params);
  },
  downloadAttachment(params,isOpen){
    return util.downloadAttachment(`${base}/api/business/downloadAttachment`,params,isOpen);
  },
  downloadAttachments(params){
    return util.downloadAttachment(`${base}/api/business/downloadAttachments`,params);
  },
  listLoginTree(params){
    return util.ajax(`${base}/api/business/listLoginTree`,params);
  },
  listLoginLog(params){
    return util.ajax(`${base}/api/business/listLoginLog`,params);
  },
  getLoginLog(id){
    return util.ajax(`${base}/api/business/getLoginLog`,id);
  },

  listAccessTree(params){
    return util.ajax(`${base}/api/business/listAccessTree`,params);
  },
  listAccessLog(params){
    return util.ajax(`${base}/api/business/listAccessLog`,params);
  },
  getAccessLog(id){
    return util.ajax(`${base}/api/business/getAccessLog`,id);
  }

  ,
  listExceptionTree(params){
    return util.ajax(`${base}/api/business/listExceptionTree`,params);
  },
  listExceptionLog(params){
    return util.ajax(`${base}/api/business/listExceptionLog`,params);
  },
  getExceptionLog(id){
    return util.ajax(`${base}/api/business/getExceptionLog`,id);
  }

  ,
  listOperationTree(params){
    return util.ajax(`${base}/api/business/listOperationTree`,params);
  },
  listOperationLog(params){
    return util.ajax(`${base}/api/business/listOperationLog`,params);
  },
  getOperationLog(id){
    return util.ajax(`${base}/api/business/getOperationLog`,id);
  },
  expOperationLog(params){
    return util.downloadAttachment(`${base}/api/business/expOperationLog`,params);
  },

  listPersonalLogTree(params){
    return util.ajax(`${base}/api/business/listPersonalLogTree`,params);
  },
  listPersonalLog(params){
    return util.ajax(`${base}/api/business/listPersonalLog`,params);
  },
  getPersonalLog(id){
    return util.ajax(`${base}/api/business/getPersonalLog`,id);
  },
  expPersonalLog(params){
    return util.downloadAttachment(`${base}/api/business/expPersonalLog`,params);
  },

  listDeveloperTree(params){
    return util.ajax(`${base}/api/business/listDeveloperTree`,params);
  },
  listDeveloperLog(params){
    return util.ajax(`${base}/api/business/listDeveloperLog`,params);
  },
  getDeveloperLog(id){
    return util.ajax(`${base}/api/business/getDeveloperLog`,id);
  },
  expDeveloperLog(params){
    return util.downloadAttachment(`${base}/api/business/expDeveloperLog`,params);
  },
  expFlowLog(params){
    return util.downloadAttachment(`${base}/api/business/expFlowLog`,params);
  },
  expExceptionLog(params){
    return util.downloadAttachment(`${base}/api/business/expExceptionLog`,params);
  },
  expLoginLog(params){
    return util.downloadAttachment(`${base}/api/business/expLoginLog`,params);
  },
  expAccessLog(params){
    return util.downloadAttachment(`${base}/api/business/expAccessLog`,params);
  },
  expServiceLog(params){
    return util.downloadAttachment(`${base}/api/business/expServiceLog`,params);
  },
  listBusinessTree(params){
    return util.ajax(`${base}/api/business/listBusinessTree`,params);
  },
  listBusinessLog(params){
    return util.ajax(`${base}/api/business/listBusinessLog`,params);
  },
  getBusinessLog(id){
    return util.ajax(`${base}/api/business/getBusinessLog`,id);
  },
  getFlowLog(id){
    return util.ajax(`${base}/api/business/getFlowLog`,id);
  },

  queryCommentProcess(...args) {
    return util.ajax(`${base}/api/process/queryCommentProcess`,...args)
  },

  getDocumentFormat(...args) {
    return util.ajax(`${base}/api/business/getDocumentFormat`,...args)
  },

  invoke(url,...args) {
    return util.ajax(`${base}/${url}`,...args)
  },

  saveRelLife(params) {
    return util.ajax(`${base}/api/business/saveRelLife`,params)
  },

  listRelFile(params) {
    return util.ajax(`${base}/api/business/listRelFile`,params)
  },

  delRelFile(params) {
    return util.ajax(`${base}/api/business/delRelFile`,params)
  },

  listServiceLog(params){
    return util.ajax(`${base}/api/business/listServiceLog`,params)
  },
  getServiceLog(id){
    return util.ajax(`${base}/api/business/getServiceLog`,id);
  },
  getTimerLog(id){
    return util.ajax(`${base}/api/business/getTimerLog`,id);
  },
  expTimerLog(params){
    return util.downloadAttachment(`${base}/api/business/expTimerLog`,params);
  },
  listTimerLog(params){
    return util.ajax(`${base}/api/business/listTimerLog`,params);
  },
  getUploadAttachFormatConfig:_.memoize(function(params){
    return util.ajax(`${base}/api/business/getUploadAttachFormatConfig`,params);
  },o=>"key"),
  getUploadMaxAttchSizeConfig:_.memoize(function(params){
    return util.ajax(`${base}/api/business/getUploadMaxAttchSizeConfig`,params);
  },o=>"key")
}



// WEBPACK FOOTER //
// ./src/common/api/business.js